import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--tab-opener"
export default class extends Controller {
  static values = { views: Array }

  open(event) {
    event.preventDefault()

    const r = /(\d+)(\.pdf)?$/

    this.viewsValue.forEach(url => {

      const windowName = "view-" + url.match(r)[0]

      window.open(url, windowName)
    });
  }
}
